<template>
  <div class="deepsea-header">
    <div class="title-heading">
      <p class="title-tagline">Careers</p>
      <h1>{{ title }}</h1>
      <div class="title-div"></div>
    </div>
    <div class="deepsea-header-bg">
      <img :src="imgPath" alt="header-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeepSea Header',
  props: {
    img: String,
  },
  data() {
    return {
      title: 'Job Opportunities',
    }
  },
  computed: {
    imgPath() {
      return require(`../assets/images/${this.img}`)
    },
  },
}
</script>

<style>
/* Mobile First Default */
.deepsea-header {
  padding: 0px;
  position: relative;
  width: 100%;
  min-height: 50vh;
}

.deepsea-header-bg {
  display: block;
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
}

.deepsea-header-bg img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.deepsea-header .title-tagline {
  color: #fddc03;
  font-size: 1em;
  font-weight: 600;
  text-align: left;
  text-transform: uppercase;
}

.deepsea-header .title-heading {
  background: rgba(0, 0, 0, 0.75);
  display: block;
  padding: 24px;
  position: absolute;
  text-align: left;
  left: 50%;
  bottom: 0%;
  transform: translate(-50%, 0%);
  width: 90%;
  max-width: 1360px;
  z-index: 5;
}

.deepsea-header .title-heading h1 {
  margin: 16px 0px;
  font-size: 2em;
  color: #ffffff;
  display: inline-block;
  width: 100%;
}

.deepsea-header .title-div {
  height: 1px;
  background-color: #fddc03;
  width: 100%;
}

/* .header-bg-img {
  background-image: url('../assets/images/header-seescan.png');
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-size: auto auto;
  margin-top: -2px;
  height: 953px;
  max-height: 953px;
  max-width: 100%;
  overflow: hidden;
  position: relative;
} */
@media screen and (min-width: 645px) {
  .deepsea-header .title-heading {
    padding: 50px;
  }
}
</style>
